import React from 'react';

class MojoHelpdeskWidget extends React.Component {
  render() {
    return (
      <div style={{ width: '1280' }}>
        <iframe
          src='https://cafe.mojohelpdesk.com/widgets/create_request#/ticket-form/72315'
          style={{ width: '100%', height: '720px', overflow: 'hidden', border: '0' }}
          onLoad={(event) => {
            const mojoWidgetCss = "#content_for_layout, body { background-color: #f8f8f8; } .section-head { } .padding-for-content { } label { } .form-control { } .form-footer { } .btn-success { }";
            event.target.contentWindow.postMessage({ 'css': mojoWidgetCss }, '*');
          }}
        ></iframe>
      </div>
    );
  }
}

export default MojoHelpdeskWidget;